import { JetView } from 'webix-jet';
import { devConfig, countries, profile } from 'config/config';

/**
 * Class representing the FilterBetsReportView.
 * @extends JetView
 */
export default class FilterBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size;

        // Left section containing date and country filters
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'DateStart',
                            id: 'DateStart',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Creación'), // Creation Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Creación'), // Creation Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'DateEnd',
                            id: 'DateEnd',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Expiración'), // Expiration Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date2',
                            id: 'Date2',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Expiración'), // Expiration Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Country option template
                                        );
                                    },
                                    data: countries, // Country data source
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() || // Conditional visibility based on config
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Default country value
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Country option template
                                        );
                                    },
                                    data: countries, // Country data source
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() || // Conditional visibility based on config
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                            css: 'country-hide',
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'State',
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'), // State label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                {
                                    id: 'C',
                                    value: _('Abierto'), // Open state
                                },
                                {
                                    id: 'S',
                                    value: _('Ganó'), // Won state
                                },
                                {
                                    id: 'N',
                                    value: _('Perdió'), // Lost state
                                },
                                {
                                    id: 'A',
                                    value: _('No Acción'), // No action state
                                },
                                {
                                    id: 'R',
                                    value: _('Pendiente'), // Pending state
                                },
                                {
                                    id: 'W',
                                    value: _('En Espera'), // Waiting state
                                },
                                {
                                    id: 'J',
                                    value: _('Rechazada'), // Rejected state
                                },
                                {
                                    id: 'M',
                                    value: _('Rechazada por Regla'), // Rejected by rule state
                                },
                                {
                                    id: 'T',
                                    value: _('Retiro Voluntario'), // Voluntary withdrawal state
                                },
                            ],
                        },
                        {
                            view: 'text',
                            name: 'PlayerId',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Usuario Id'), // User ID label
                            labelPosition: 'top',
                            placeholder: _('Usuario Id '),
                        },
                        {
                            view: 'text',
                            name: 'TicketId',
                            label: "<span class='icon-ticket'></span>" + _('Ticket Id'), // Ticket ID label
                            labelPosition: 'top',
                            placeholder: _('Ticket Id '),
                        },
                        {
                            view: 'text',
                            name: 'Ip',
                            label: "<span class='icon-ip'></span>" + _('Dirección IP'), // IP Address label
                            labelPosition: 'top',
                            placeholder: _('Direccion IP '),
                        },
                        {
                            view: 'richselect',
                            name: 'TypeBet',
                            label: _('Tipo de Apuesta'), // Bet type label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: 2, // Default bet type value
                            options: [
                                { id: '1', value: _('Apuestas Creadas') }, // Created bets
                                { id: '2', value: _('Apuestas Cerradas') }, // Closed bets
                                { id: '3', value: _('Apuestas Pagadas') }, // Paid bets
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    id: 'Sort',
                    cols: [
                        {
                            view: 'combo',
                            name: 'Sort',
                            label: _('Ordenar por'), // Sort by label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Fecha Creación') }, // Sort by creation date
                                { id: '2', value: _('Usuario Id') }, // Sort by user ID
                                { id: '3', value: _('Valor') }, // Sort by value
                            ],
                            value: '1', // Default sort option
                        },
                        {
                            view: 'combo',
                            name: 'Dir',
                            label: _('Orden'), // Order label
                            labelPosition: 'top',
                            options: [
                                { id: '0', value: _('Ascendente') }, // Ascending order
                                { id: '1', value: _('Descendente') }, // Descending order
                            ],
                            value: '0', // Default order option
                        },
                        { gravity: 1, id: 'grav3' },
                        { gravity: 1, id: 'grav4' },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    height: document.body.offsetWidth < 500 ? 120 : 0,
                    cols: [
                        {
                            view: 'radio',
                            name: 'TypeUser',
                            label: _('Tipo de usuario'), // User type label
                            labelPosition: 'top',
                            value: 0, // Default user type value
                            options: [
                                { id: 0, value: _('Todos') }, // All users
                                {
                                    id: 1,
                                    value: "<span class='icon-players'></span> ", // Player type
                                },
                                {
                                    id: 2,
                                    value: "<span class='icon-shop'></span>", // Shop type
                                },
                            ],
                        },
                        { gravity: 1, id: 'grav5' },
                        { gravity: 1, id: 'grav6' },
                        { gravity: 1, id: 'grav7' },
                    ],
                },
            ],
        };

        // Left section for minimum and maximum prize values
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'ValueMinimum',
                            type: 'number',
                            label: "<span class='icon-cash'></span>" + _('Premio Total Mínimo'), // Minimum total prize label
                            labelPosition: 'top',
                            placeholder: _('Premio Total Mínimo'),
                        },
                        {
                            view: 'text',
                            name: 'ValueMaximum',
                            type: 'number',
                            label: "<span class='icon-cash'></span>" + _('Premio Total Máximo'), // Maximum total prize label
                            labelPosition: 'top',
                            placeholder: _('Premio Total Máximo'),
                        },
                    ],
                },
            ],
        };

        // Upper section containing the main filter layout
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 760 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Upper section for additional filters
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 120 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Advanced filters header
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { gravity: 1, id: 'grav' },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                $$('myForm').setValues(
                                    $$('myForm').getCleanValues(), // Reset form values
                                );
                                $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                                $$('Datepicker').setValue(''); // Clear datepicker
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Consult button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile
                                }
                                delete filterdata['CountrySelect2']; // Remove unused field
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date fields based on profile
                                    delete filterdata['Date2'];
                                } else {
                                    if (true) {
                                        delete filterdata['DateStart'];
                                        delete filterdata['DateEnd'];
                                    }
                                }
                                this.app.callEvent('casinoReport:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                                $$('b5').collapse(); // Collapse advanced filters
                                $$('a5').scrollTo(100, 0); // Scroll to specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for main filters
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Filters header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, accordion_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Main form configuration
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [accordion_section2],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide elements for small screens
                $$('grav3').hide();
                $$('grav4').hide();
                $$('grav5').hide();
                $$('grav6').hide();
                $$('grav7').hide();
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Show/hide date fields based on profile
                $$('Date2').hide();
                $$('DateStart').show();
                $$('DateEnd').show();
            } else {
                if (true) {
                    $$('Date').show();
                    $$('Date2').show();
                    $$('DateStart').hide();
                    $$('DateEnd').hide();
                }
            }
        });
    }
}

// FILE DOCUMENTED
